export default __webpack_public_path__ + "static/media/brands_white.17055b63.svg";